import Evented from "@ember/object/evented"
import Service from "@ember/service"
import $ from "jquery"

export default class MouseEvents extends Service.extend(Evented) {
  init() {
    super.init(...arguments)
    $(document).on("mousedown", (e) => this.trigger("mouseDown", e))
    // this.on('mouseDown', function(e){
    //   console.log('e', e)
    // })
  }

  willDestroy() {
    super.willDestroy(...arguments)
    $(document).off("mousedown", this.trigger.bind("mouseDown"))
  }
}
